export default __webpack_public_path__ + "static/media/w5.e12214f6.jpg";